var exports = {
  "k": "x234b8571--de3cdc--container",
  "A": "x234b8571--de3cdc--item",
};

module.exports = exports;
